import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';

const AdminFeatureCard = ({ title, description, icon, color, onClick }) => (
  <Card 
    style={{ 
      height: '100%', 
      cursor: 'pointer',
      transition: 'transform 0.2s',
      border: `2px solid ${color}`,
      '&:hover': { transform: 'translateY(-4px)' }
    }}
    onClick={onClick}
  >
    <CardContent style={{ textAlign: 'center', padding: 24 }}>
      <Box display="flex" justifyContent="center" mb={2}>
        <div style={{ color, fontSize: 48 }}>
          {icon}
        </div>
      </Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
    </CardContent>
  </Card>
);

export default AdminFeatureCard; 